import { useQuery } from '@tanstack/react-query';
import { vehicleDatabaseService } from '@/services';
import type { VehicleDatabaseListParams } from '@/services/vehicleDatabase';

/** The broker's own vehicles, keyed by registration number. */
export function useVehicleDatabase(params: VehicleDatabaseListParams = {}) {
  const { search, mine, ordering, offset } = params;
  return useQuery({
    // B-01: `offset` belongs in the KEY as well as in the request. Left out of
    // it, every page of the same filters shared one cache entry, so page 2 was
    // served page 1 from cache and the request that would have fetched it was
    // never made.
    queryKey: ['vehicle-database', search ?? '', mine ?? false, ordering ?? '', offset ?? 0],
    queryFn: () => vehicleDatabaseService.list(params),
    placeholderData: (previous) => previous,
  });
}

/** One vehicle and its history. */
export function useVehicleDatabaseEntry(registrationNumber: string | null) {
  return useQuery({
    queryKey: ['vehicle-database-entry', registrationNumber ?? ''],
    queryFn: () => vehicleDatabaseService.get(registrationNumber!),
    enabled: !!registrationNumber,
    retry: false,
  });
}
